<template>
  <div>
    <!-- <vue-json-pretty :path="'res'" :data="data"></vue-json-pretty> -->
    Data:
    <pre>{{ dataPretty }}</pre>
  </div>
</template>

<script>
// import * as VueJsonPretty from 'vue-json-pretty'
// import 'vue-json-pretty/lib/styles.css'

export default {
  // components: {
  //   VueJsonPretty
  // },

  props: {
    data: Object
  },

  computed: {
    dataPretty () {
      if (this.data && this.data !== null && typeof this.data === 'object' && Object.keys(this.data).length) {
        return JSON.stringify(this.data, null, 2)
      }

      return ''
    }
  },

  filters: {
    pretty: function (value) {
      if (value && value !== null && typeof value === 'object' && value.length > 0) {
        return JSON.stringify(JSON.parse(value), null, 2)
      }

      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/VueJsonPrettyWrapper.vue